<template>
  <div class="membres" :class="{ marginBandeau: $store.state.bandeau }">
    <div v-if="$store.state.data" v-show="initiated" class="panelRecherche">
      <div v-show="showCriteres === true" class="criteres">
        <div class="form">
          <div class="label">
            <label>Je cherche</label>
          </div>
          <div class="value">
            <select v-model="pattern.sex">
              <option value="0">
                Indifférent
              </option>
              <option value="FEMALE">
                Une femme
              </option>
              <option value="MALE">
                Un homme
              </option>
            </select>
          </div>

          <div class="label">
            <label>Qui recherche</label>
          </div>
          <div class="value">
            <select v-model="pattern.idOrientation">
              <option value="0">
                Choisir
              </option>
              <option v-for="data in listeOrientations" :key="data.id" :value="data.id">
                {{ getName(data) }}
              </option>
            </select>
          </div>

          <div class="label">
            <label>Son âge</label>
          </div>
          <div class="value">
            De
            <select v-model="pattern.ageMin" class="age">
              <option v-for="i in 82" :key="i + 17" :value="i + 17">
                {{ i + 17 }}
              </option>
            </select>
            à
            <select v-model="pattern.ageMax" class="age">
              <option v-for="i in 82" :key="i + 17" :value="i + 17">
                {{ i + 17 }}
              </option>
            </select>
            ans
          </div>

          <div class="label">
            <label>Son statut</label>
          </div>
          <div class="value">
            <select v-model="pattern.idStatut">
              <option value="0">
                Choisir
              </option>
              <option v-for="data in listeStatut" :key="data.id" :value="data.id">
                {{ getName(data) }}
              </option>
            </select>
          </div>

          <div class="label">
            <label>Son handicap</label>
          </div>
          <div class="value">
            <select v-model="pattern.idHandicap">
              <option value="0">
                Choisir
              </option>
              <option v-for="data in listeHandicap" :key="data.id" :value="data.id">
                {{ getName(data) }}
              </option>
            </select>
          </div>

          <div class="label">
            <label>Son pays</label>
          </div>
          <div class="value">
            <select v-model="pattern.id_country" @change="countryChanged">
              <option :value="0">
                Choisir
              </option>
              <option v-for="data in countries" :key="data.id" :value="data.id">
                {{ data.name }}
              </option>
            </select>
          </div>

          <div class="label">
            <label>Sa région</label>
          </div>
          <div class="value">
            <select v-model="pattern.id_region" :disabled="regions.length === 0" @change="regionChanged">
              <option :value="0">
                Choisir
              </option>
              <option v-for="data in regions" :key="data.id" :value="data.id">
                {{ data.name }}
              </option>
            </select>
          </div>

          <div class="label">
            <label>Son département</label>
          </div>
          <div class="value">
            <select v-model="pattern.id_department" :disabled="departments.length === 0">
              <option :value="0">
                Choisir
              </option>
              <option v-for="data in departments" :key="data.id" :value="data.id">
                {{ data.name }}
              </option>
            </select>
          </div>
          <div class="label">
            <label>Sa photo</label>
          </div>
          <div class="value check">
            <select v-model="pattern.withPicture">
              <option :value="false">
                Indifférent
              </option>
              <option :value="true">
                Avec photo uniquement
              </option>
            </select>
          </div>
          <div class="label">
            <label>Son pseudo</label>
          </div>
          <div class="value">
            <input v-model="pattern.pseudo" type="text" />
          </div>

          <div class="label">
            <label>Mot clé</label>
          </div>
          <div class="value">
            <input v-model="pattern.keyWord" type="text" />
          </div>

          <div class="label">
            <label>Ordre des résultats</label>
          </div>
          <div class="value">
            <select v-model="pattern.newest" type="checkbox">
              <option :value="false">Derniers connectés en premier</option>
              <option :value="true">Derniers inscrits en premier</option>
            </select>
          </div>
        </div>
      </div>

      <div class="boutonRechercher">
        <a @click="rechercher" class="bouton rose">{{ buttonLabel }}</a>
      </div>
    </div>
    <ListeMembres class="listeRes" ref="liste" :pattern="pattern" :save="true">
      <h3>Votre recherche n'a donné aucun résultat.</h3>
      <p>
        Vous pouvez élargir les critères de recherche pour obtenir des résultats. Si vous possédez un Pass Sérénité et
        que vous avez activé le filtre de contacts, il est possible que certains résultats soit exclus par votre filtre.
      </p>
      <p>
        Vous pouvez cliquer sur le bouton ci-dessous pour réinitialiser tous vos critères de recherche afin d'obtenir
        plus de résultats. <br /><br />
        <a @click.prevent="initPattern" href="#" class="bouton">Réinitialiser ma recherche</a>
      </p>
    </ListeMembres>
  </div>
</template>

<script>
import ListeMembres from "@/components/membres/ListeMembres";
import BaseMembres from "@/components/membres/BaseMembres";
import { idyuGetCountries, idyuGetRegions, idyuGetDepartments } from "@/assets/js/idyu/reference.js";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "Recherche",
  components: { ListeMembres },
  extends: BaseMembres,
  data() {
    return {
      countries: [],
      regions: [],
      departments: [],
      showCriteres: true,
      initiated: false
    };
  },
  computed: {
    listeOrientations: function() {
      return this.$store.state.data.data[34].filter(this.filterFirst);
    },

    listeStatut: function() {
      return this.$store.state.data.data[0].filter(this.filterFirst);
    },

    listeHandicap: function() {
      return this.$store.state.data.data[12].filter(this.filterFirst);
    },

    buttonLabel: function() {
      if (this.showCriteres) return "Rechercher";
      return "Nouvelle recherche";
    },

    mobileMode: function() {
      return this.$store.state.windowWidth <= 780;
    }
  },

  created: async function() {
    this.countries = await idyuGetCountries();
  },

  methods: {
    filterFirst: function(elt) {
      return elt.ord > 1;
    },

    initPattern: function() {
      this.baseInitPattern();
      this.patternName = "Recherche";
      this.pattern.ageMin = 18;
      this.pattern.ageMax = 99;
      this.pattern.sex = "0";
      this.pattern.id_country = 0;
      this.pattern.id_region = 0;
      this.pattern.id_department = 0;
      this.pattern.idOrientation = 0;
      this.pattern.idStatut = 0;
      this.pattern.idHandicap = 0;
      this.pattern.withPicture = false;
      this.pattern.newest = false;
      this.pattern.pseudo = "";
      this.pattern.keyWord = "";
    },

    getName: function(data) {
      return data.name[this.$store.state.lang].name;
    },

    rechercher: async function() {
      if (this.showCriteres) {
        this.pattern.pageNumber = "0";
        if (this.mobileMode == true) {
          this.showCriteres = false;
        }
        await this.$refs.liste.init();
      } else {
        this.showCriteres = true;
        this.pattern.pseudo = "";
        this.pattern.keyWord = "";
      }
    },

    countryChanged: async function() {
      if (this.pattern.id_country === 0) this.pattern.regions = [];
      else {
        this.departments = [];
        this.pattern.id_department = 0;
        this.regions = await idyuGetRegions(this.pattern.id_country);
        this.pattern.id_region = 0;
      }
    },

    regionChanged: async function() {
      if (this.pattern.id_region === 0) this.departments = [];
      else {
        this.departments = await idyuGetDepartments(this.pattern.id_region);
        this.pattern.id_department = 0;
      }
    },

    init: async function() {
      this.$store.commit("setLoading", true);
      const lastSearch = await idyuJsonRpc("getLastSearch");
      if (lastSearch) {
        this.pattern = lastSearch;
        if (!this.pattern.sex) this.pattern.sex = "0";
        this.pattern.pseudo = "";
        this.pattern.keyWord = "";
        const reg = this.pattern.id_region;
        const dep = this.pattern.id_department;
        if (this.pattern.id_country && this.pattern.id_country !== 0) {
          await this.countryChanged();
          if (reg && reg !== 0) {
            this.pattern.id_region = reg;
            await this.regionChanged();
            this.pattern.id_department = dep;
          }
        }

        this.baseInitPattern();
        this.initiate = true;
        if (!this.mobileMode) await this.$refs.liste.init();
      }
      this.$store.commit("setLoading", false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";
@import "@/assets/css/forms.scss";
@import "@/assets/css/base_membres.scss";

.label {
  text-align: right;
}

.membres {
  grid-template-columns: max-content auto;
  grid-template-rows: auto;
}

.panelRecherche {
  width: 400px;
}

.boutonRechercher {
  display: grid;
  grid-template-columns: min-content;
  align-content: center;
  align-items: center;
  justify-content: center;
}

select.age {
  width: auto !important;
}

.criteres {
  display: grid;
  grid-template-columns: auto;
  grid-auto-rows: min-content;
  grid-gap: $content_margins;
  padding-bottom: 10px;
}

.boutonRechercher a {
  padding: 5px;
  width: 200px;
}

.membresBox {
  top: 0;
  left: 410px;
}

@media screen and (max-width: 450px) {
  .criteres {
    grid-template-columns: auto;
  }
}

@media screen and (max-width: 944px) {
  .slide-enter,
  .slide-leave-to {
    margin-top: -456px;
  }
}

@media screen and (max-width: 780px) {
  .membresBox {
    position: relative;
    top: 0;
    left: 0px;
  }

  .panelRecherche {
    width: unset;
  }
  .membres {
    grid-template-columns: auto;
    grid-template-rows: min-content;
    overflow-y: auto;
  }

  .form {
    white-space: nowrap;
    grid-template-columns: auto !important;
    grid-template-rows: auto !important;
    grid-gap: 5px;
    .value {
      grid-column: 1 !important;
    }

    .label {
      padding-left: 3px;
      padding-bottom: 0px;
      text-align: left;
      width: auto;
    }
  }
}
</style>
